import { jsx as _jsx } from "react/jsx-runtime";
export const SvgCaretRight = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { "data-rotate": '-90deg', d: 'm7.5 10.5 4.5 4 4.5-4' }) }));
//# sourceMappingURL=caret-right.js.map